module.exports = __webpack_public_path__ + "kudos_54.svg?ba5c7fe66a18b549168fa29de1ee0de2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_54.svg
// module id = 155
// module chunks = 0